import React from 'react'
import { RichText} from 'prismic-reactjs'
import htmlSerializer from '@utils/HtmlSerializer'
import LinkResolver from '@utils/LinkResolver'
import moment from '@utils/moment'
// import {DateDisplay} from '@utils/DateDisplay'
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import RelatedContent from '@components/Orientation/RelatedContent'

const Session = ({item, index}) => {
    if (item == null) return null
    return (
       <div>
        <div key={"date-session-"+index}>
        <h2 className="h4">
            <a className="expand collapsed" data-toggle="collapse" href={"#session-"+index} role="button" aria-expanded="false" aria-controls={"session-"+index}>
            {moment(item.orientation_session_date).format('dddd[,] MMMM Do[,] YYYY')} {item.orientation_session_title  ? ": " + item.orientation_session_title : ""} 
            {/* {item.orientation_session_date} {item.orientation_session_title} */}
            <FontAwesomeIcon icon={faCaretDown}/>
            </a>
        </h2>
        <div className="collapse" id={"session-"+index}>
            <RichText render={item.orientation_session_contents} linkResolver={LinkResolver} htmlSerializer={htmlSerializer}/> 
            <RelatedContent relatedContent={item.related_content}/>
        </div>
        </div>
        <hr/>
       </div>
    )  
}

export default Session;

